import { h } from 'preact'
import UserAvatar from '../User/UserAvatar'
import {AuthorType} from './Types'

const PostAuthor = ({ author }: { author: AuthorType }) => {
  return (
    <UserAvatar
      user={{ ...author, ...{ name: author.username } }}
      extraClass='avatar avatar--responsive'
      showRank
    />
  )
}

export default PostAuthor
